import { LocalStorageKey } from '@app/shared/services/local-storage.service'

export const libraryManagementFeatureKey = 'libraryManagement'

export const libraryShowAllRateCardItemsKey = LocalStorageKey.LIBRARY__SHOW_ALL_RATE_CARD_ITEMS
